import React from 'react';

function prodStateClass(prodState) {
  return prodState?.toLowerCase().replace(/\s+/g, '-') || '';
}

function OverlaySpecs({ vehicle, showProdState }) {
  return (
    <div className="overlay-content">
      {showProdState && (
        <div className="overlay-prod">
          <span className={`prod-state ${prodStateClass(vehicle.prodState)}`}>
            {vehicle.prodState}
          </span>
        </div>
      )}

      <div className="overlay-left">
        {['focus', 'weapons', 'missiles', 'turrets', 'speed'].map((key) => (
          <div key={key} className={`spec-line ${key}`}>
            <span className="spec-label">{key}</span>
            <span className="spec-value">{vehicle[key]}</span>
          </div>
        ))}
      </div>

      <div className="overlay-right">
        <div className="spec-line size">
          <span className="spec-label">Size</span>
          <span className="spec-value">{vehicle.size}</span>
        </div>
        <div className="spec-line length">
          <span className="spec-label">Length</span>
          <span className="spec-value">{vehicle.length}</span>
        </div>
        <div className="spec-line width">
          <span className="spec-label">Width</span>
          <span className="spec-value">{vehicle.beam}</span>
        </div>
        <div className="spec-line height">
          <span className="spec-label">Height</span>
          <span className="spec-value">{vehicle.height}</span>
        </div>
        <div className="spec-line cargo">
          <span className="spec-label">Cargo</span>
          <span className="spec-value">{vehicle.cargoCapacity} SCU</span>
        </div>
      </div>
    </div>
  );
}

function OverlayExtras({ vehicle, isLoaner, compact }) {
  const skins = vehicle.skins || [];
  const insurances = vehicle.insurances || [];
  const hasExtras = skins.length > 0 || (!isLoaner && insurances.length > 0);

  if (!hasExtras && !vehicle.rsiPath) return null;

  const skinsBlock = skins.length > 0 ? (
    <div className="vehicle-skins">
      {skins.map((skin, index) => (
        <div key={index} className="vehicle-skin">
          {skin.itemName}
        </div>
      ))}
    </div>
  ) : null;

  const insurancesBlock = !isLoaner && insurances.length > 0 ? (
    <div className="vehicle-insurances">
      {insurances.map((insurance, index) => (
        <div key={index} className="vehicle-insurance">
          {insurance.itemName}
        </div>
      ))}
    </div>
  ) : null;

  const rsiLink = vehicle.rsiPath ? (
    <a
      className="vehicle-rsi-link"
      href={vehicle.rsiPath}
      target="_blank"
      rel="noreferrer"
      onClick={(event) => event.stopPropagation()}
    >
      View on RSI
    </a>
  ) : null;

  if (compact) {
    if (!hasExtras) {
      return rsiLink;
    }

    return (
      <>
        <div className="vehicle-overlay-panel__extras">
          {skinsBlock}
          {insurancesBlock}
        </div>
        {rsiLink}
      </>
    );
  }

  return (
    <>
      {skinsBlock}
      {insurancesBlock}
      {rsiLink}
    </>
  );
}

export default function VehicleOverlayPanel({
  vehicle,
  isLoaner = false,
  compact = false,
}) {
  if (compact) {
    return (
      <div className="vehicle-overlay-panel vehicle-overlay-panel--compact">
        <OverlaySpecs vehicle={vehicle} showProdState={false} />
        <OverlayExtras vehicle={vehicle} isLoaner={isLoaner} compact />
      </div>
    );
  }

  return (
    <>
      <OverlaySpecs vehicle={vehicle} showProdState />
      <OverlayExtras vehicle={vehicle} isLoaner={isLoaner} compact={false} />
    </>
  );
}
